import { Form } from 'react-bootstrap';
import FlowProperties from './node_types/FlowProperties';

const NodeTypeProperties = ({ state, onChange }) => {
  const { type } = state;

  if (!type) return null;

  const nodeTypeComponents = {
    flow: FlowProperties,
  };

  const NodeTypeComponent = nodeTypeComponents[type];

  if (!NodeTypeComponent) return null;

  return <NodeTypeComponent state={state} onChange={onChange} />;
};

export default NodeTypeProperties;
